import { c as _c } from "react/compiler-runtime";
import MUISkeleton, { SkeletonProps } from '@mui/material/Skeleton';
import { SystemStyleObject } from '@mui/system';
import { ReactNode } from 'react';
import Box from '../Box';
import radius from '../Theme/radius';
import Repeat from '../Repeat';
import { SxProps, Theme } from '../styles';
type Variant = Exclude<SkeletonProps['variant'], undefined>;
const MUI_VARIANT: { [key in Variant]: SystemStyleObject<Theme> } = {
  circular: {
    backgroundColor: 'skeleton.image',
    width: 200,
    height: 200
  },
  rectangular: {
    backgroundColor: 'skeleton.text'
  },
  rounded: {
    backgroundColor: 'skeleton.image'
  },
  text: {
    backgroundColor: 'skeleton.text',
    height: 26,
    maxWidth: 768,
    borderRadius: 0
  },
  button: {
    backgroundColor: 'skeleton.badge',
    height: 40,
    width: 100,
    borderRadius: radius.interaction
  }
};
export interface Props extends Omit<SkeletonProps, 'animation'> {
  count?: number;
  children?: ReactNode;
  sx?: SxProps<Theme>;
}
const Skeleton = t0 => {
  const $ = _c(29);
  let children;
  let height;
  let otherProps;
  let t1;
  let t2;
  let t3;
  let width;
  if ($[0] !== t0) {
    ({
      count: t1,
      variant: t2,
      children,
      sx: t3,
      height,
      width,
      ...otherProps
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = height;
    $[3] = otherProps;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
    $[7] = width;
  } else {
    children = $[1];
    height = $[2];
    otherProps = $[3];
    t1 = $[4];
    t2 = $[5];
    t3 = $[6];
    width = $[7];
  }
  const count = t1 === undefined ? 1 : t1;
  const variant = t2 === undefined ? "text" : t2;
  let t4;
  if ($[8] !== t3) {
    t4 = t3 === undefined ? {} : t3;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const sx = t4;
  let t5;
  if ($[10] !== height || $[11] !== width) {
    t5 = {
      width,
      height
    };
    $[10] = height;
    $[11] = width;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  const t6 = MUI_VARIANT[variant];
  let t7;
  if ($[13] !== sx || $[14] !== t6) {
    t7 = {
      ...t6,
      ...sx
    };
    $[13] = sx;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== children || $[17] !== height || $[18] !== t7 || $[19] !== variant || $[20] !== width) {
    t8 = <MUISkeleton variant={variant} animation="wave" height={height} width={width} sx={t7}>{children}</MUISkeleton>;
    $[16] = children;
    $[17] = height;
    $[18] = t7;
    $[19] = variant;
    $[20] = width;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  let t9;
  if ($[22] !== count || $[23] !== t8) {
    t9 = <Repeat count={count}>{t8}</Repeat>;
    $[22] = count;
    $[23] = t8;
    $[24] = t9;
  } else {
    t9 = $[24];
  }
  let t10;
  if ($[25] !== otherProps || $[26] !== t5 || $[27] !== t9) {
    t10 = <Box sx={t5} {...otherProps}>{t9}</Box>;
    $[25] = otherProps;
    $[26] = t5;
    $[27] = t9;
    $[28] = t10;
  } else {
    t10 = $[28];
  }
  return t10;
};
export default Skeleton;